import { gql } from "@apollo/client";

export default gql`
  query getChangelogSettings{
    getChangelogSettings{
        success
        data{
            _id
            defaultLanguage
            supportedLanguages
            defaultTimezone
            dateFormat
            senderEmail
            senderWhatsapp
            senderCustomerId
            recipientAudience
            includeInactiveCustomers
            includeArchivedPersons
            updatedAt
        }
        error
        message
    }
}
`
